import { useRMSelector } from 'redux/hooks';

export const useSelectPreviewArchivingData = () => {
  return useRMSelector((state) => state.archiving.previewArchiving);
};

export const useSelectArchivingResults = () => {
  return useRMSelector((state) => state.archiving.archivingResults);
};

export const useSelectPreviewFilters = () => {
  return useRMSelector((state) => state.archiving.previewFilters);
};
